/**
 * Created by asiulik on 01.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../utils'], function($, _, EventEmitter, Utils){

    var additionalOverlayPageTypes = [
        'popup',
        'page'
    ];

    var config = {
        pageOverlaySelector: "#pageOverlay",
        pageOverlayTrigger: "[data-page-url]",
        pageOverlayTriggerAttr: "data-page-url",
        pageOverlayTypeAttr: "data-page-overlay-type",
        pageOverlayPageContentElement: '#pageContentElement',
        pagePreloaderSelector: "#overlayPagePreloader"
    };

    function OverlayPage(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlayPage.prototype = _.clone(EventEmitter.prototype);

    OverlayPage.prototype.init = function(){

        this.$pageOverlay = $(config.pageOverlaySelector);
        this.$pageTriggerElements = $(config.pageOverlayTrigger);

        this.$pageContentElement = this.$pageOverlay.find(
            config.pageOverlayPageContentElement
        );

        this.$pageOverlayPreloader = this.$pageOverlay.find(
            config.pagePreloaderSelector
        );

        this.bindEvents();

    };

    OverlayPage.prototype.bindEvents = function(){

        var _this = this;

        this.$pageTriggerElements.on({
            click: function(e){

                e.preventDefault();

                var $element = $(e.currentTarget);

                _this.prepareOverlayToDisplayInCorrectType(
                    $element.attr(
                        config.pageOverlayTypeAttr
                    )
                );

                _this.displayPageInOverlay($element.attr(
                    config.pageOverlayTriggerAttr
                ));
            }
        });

        this.overlay.on('hideOverlay', function(){

            _this.clearOverlatAdditionalTypesClass();

            setTimeout(function(){
                _this.updateOverlayContent('');
            }, 700);

        });

    };

    OverlayPage.prototype.prepareOverlayToDisplayInCorrectType = function(type){

        var _this = this;

        switch(type) {

            case "popup":
                _this.$pageOverlay.addClass('overlay--popup');
                break;
            default:
                _this.$pageOverlay.addClass('overlay--page');
                break;
        }

    };

    OverlayPage.prototype.clearOverlatAdditionalTypesClass = function(){

        this.$pageOverlay.removeClass(additionalOverlayPageTypes.map(function(type){
           return ' overlay--' + type
        }));

    };

    OverlayPage.prototype.displayPageInOverlay = function(pageUrl){

        var _this = this;

        this.overlay.openOverlay(this.$pageOverlay);

        this.$pageOverlayPreloader.removeClass('preloader--hidden');
        this.getPageContent(pageUrl).then(function($content) {

            _this.updateOverlayContent($content);
            _this.emit('overlay:page:contentAdded', _this.$pageContentElement);

            _this.$pageOverlayPreloader.addClass('preloader--hidden');

        })

    };

    OverlayPage.prototype.updateOverlayContent = function($content){
        this.$pageContentElement.html($content);
    };

    OverlayPage.prototype.getPageContent = function(url){

        var getPageContentPromise = Utils.createPromise();

        Utils.getPageByAjaxLimitedToContentElements(url).then(function($content){

            window.tracking.trackGTM({
                'event': 'overlay',
                'action': 'overlayPage',
                'value': url
            });

            window.tracking.trackGA([
                'send',
                'event',
                'overlay',
                'overlayPage',
                url
            ]);

            setTimeout(function(){
                getPageContentPromise.resolve($content);
            }, 3000);
        });

        return getPageContentPromise.promise();

    };

    return OverlayPage;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlayPage.js